import { render, staticRenderFns } from "./CoreHeader.vue?vue&type=template&id=162422d2"
import script from "./CoreHeader.vue?vue&type=script&lang=js"
export * from "./CoreHeader.vue?vue&type=script&lang=js"
import style0 from "./CoreHeader.vue?vue&type=style&index=0&id=162422d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports